import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                position: "fixed",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: theme.relode.sizes.mobileAppBarHeight,
                borderBottom: `1px solid ${theme.palette.divider}`,
                backgroundColor: "white",
                paddingLeft: 16,
                paddingRight: 16,
                width: "100%",
                zIndex: 1000,
            },
        }),
    { name: "MobileTitleBar" }
);

export const MobileTitleBar = (props: { children?: React.ReactNode }) => {
    const classes = useStyles({});
    return (
        <div id="mobile-title-bar" className={classes.root}>
            {props.children}
        </div>
    );
};
